/*@ngInject*/
const CollaborationUtil = function () {
    this.getEmailIdentifierString = (name, emailAddress) => {
        return `"${name}" <${emailAddress}>`;
    };
};

angular.module('gw-um-submission')
    .service('collaborationUtil', CollaborationUtil);
